import { Action, createFeatureSelector } from '@ngrx/store';
import * as fromEcg from './ecg-viewer.reducer';

export const key = 'ecg';

export function reducers(state: fromEcg.ECGState | undefined, action: Action) {
    return fromEcg.reducer(state, action);
}

export const selectLayoutEditState = createFeatureSelector<fromEcg.ECGState>(key);
